import "toastr";

export default class MiniQuote {
  static load() {
    const q = $.ajax({
      type: "GET",
      url: "/api/quote/mini"
    });

    q.done((data: number) => {
      const $counter = $(".js-mini-quote-count");
      const $miniQuote = $(".nt-mini-quote");
      $counter.text(data);
      if (data === 0) {
        $miniQuote.addClass("nt-mini-quote--empty");
      } else {
        $miniQuote.removeClass("nt-mini-quote--empty");
      }
    });

    q.fail((xhr, textStatus, errorThrown) => {
      // @ts-ignore
      toastr["error"]("Could not load mini quote.");
    });
  }
}